import axios from 'axios';

// Get all warehouses
export const getWarehouses = async (filters = {}) => {
  try {
    let queryString = '';
    if (filters.name) queryString += `name=${encodeURIComponent(filters.name)}&`;
    
    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/warehouses?${queryString}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching warehouses' };
  }
};

// Get warehouse by ID
export const getWarehouseById = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/warehouses/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching warehouse details' };
  }
};

// Create new warehouse
export const createWarehouse = async (warehouseData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post('/api/warehouses', warehouseData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error creating warehouse' };
  }
};

// Update warehouse
export const updateWarehouse = async (id, warehouseData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.put(`/api/warehouses/${id}`, warehouseData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error updating warehouse' };
  }
};

// Delete warehouse
export const deleteWarehouse = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.delete(`/api/warehouses/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error deleting warehouse' };
  }
};